import React from "react";
import { Container, Row, Col, Card, Accordion } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaBook, FaFileAlt, FaEnvelope, FaUsers, FaBriefcase, FaQuestionCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom'

const Resources = () => {
  return (
    <Container className="my-5">
      <motion.h1
        className="text-center fw-bold mb-5 text-primary"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ fontFamily: "Space Mono, monospace" }}
      >
        Полезные ресурсы для студентов и выпускников ОшТУ
      </motion.h1>
    </Container>
  );
};

export default Resources;
